module.exports = __webpack_public_path__ + "assets/img/101402.c50a91b1.svg";